// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main[data-v-ddfd255c]{padding:0 0;display:flex;background-color:#f1f4fa}.content[data-v-ddfd255c]{display:inline-block;height:calc(100vh - 96px);width:calc(100% - 30px);padding:0 15px 0 15px;overflow-x:auto;text-align:left}.footplaceholder[data-v-ddfd255c]{height:30px}", ""]);
// Exports
module.exports = exports;
